import {Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {TerritorialAuthorityProvider} from '@providers/territorial-authority/territorial-authority.provider';
import {Subscription} from 'rxjs';

/**
 * Директива для отображения регионов Ростехнадзора в зависимости от выбранного Id
 */
@Directive({selector: '[appRostehRegionsPreview]'})
export class RostehRegionsPreviewDirective implements OnChanges, OnInit, OnDestroy {
    @Input() rostehId: number;

    private sub: Subscription;

    constructor(
        private rostehProvider: TerritorialAuthorityProvider,
        private er: ElementRef,
    ) {}

    ngOnInit() {
        this.sub = this.rostehProvider.data$.subscribe(() => {
            this.updateContent();
        });
    }

    ngOnChanges() {
        this.updateContent();
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    private updateContent() {
        if (!this.rostehId) {
            this.setContent('');
            return;
        }

        const rosteh = this.rostehProvider.getById(this.rostehId);
        this.setContent(rosteh ? rosteh.region : '');
    }

    private setContent(message: string) {
        this.er.nativeElement.innerHTML = message;
    }
}
